/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'headerIcons/interests': {
    width: 17,
    height: 24,
    viewBox: '0 0 17 24',
    data: '<defs><path pid="0" id="svgicon_headerIcons_interests_a" d="M0 0h16.758v23.987H0z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_headerIcons_interests_b" _fill="#fff"><use xlink:href="#svgicon_headerIcons_interests_a"/></mask><path pid="1" d="M.094 15.444c.5 4.516 3.49 8.518 8.4 8.543 2.82.014 5.511-1.502 7.024-3.872 1.871-2.933 1.456-6.49-.123-9.458-1.458-2.74-3.996-5.003-4.505-8.21-.046-.295-.37-2.302-.093-2.447a11.857 11.857 0 00-6.182 8.528 4.64 4.64 0 01-1.009-4.695 15.422 15.422 0 00-3.512 11.61" _fill="#000" mask="url(#svgicon_headerIcons_interests_b)"/></g>'
  }
})
